import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useAuth from 'context/useAuth';
import { tagForm } from 'tagManager';

import FocusableHeader from 'components/focusableheader/FocusableHeader';
import { TextButtonSto } from 'components/sto';
import { AppRoutes } from 'routes';
import { retrieveUsername } from 'services/AccountService';

import AccountDetailsForm from '../../components/accountForm/AccountDetailsForm';
import forgotUserNameErrors from '../../components/errors/forgotUserNameError';
import RadioButton from '../../components/inputs/RadioButton';
import Link from '../../components/link/Link';
import RetrievePassword from '../../components/resetPassword/retrievePassword';
import UpdatePasswordForm from '../../components/resetPassword/UpdatePasswordForm';
import OverlaySpinner from '../../components/spinner/OverlaySpinner';
import useLocalization from '../../hooks/useLocalization';
import scrollTo from '../../utils/scrollTo';

const RetrieveCredentialsView = () => {
    const { localizedPush } = useLocalization();
    const { setForgotCredsUsername } = useAuth();
    const [recoveryType, setRecoverType] = useState('password');
    const [displayedSection, updateDisplayedSection] = useState('forgotCredentials');
    const [username, setUsername] = useState(null);
    const [email, setEmail] = useState(null);
    const [error, setError] = useState(null);
    const [isFetchingUsername, setIsFetchingUsername] = useState(false);

    const forgotPassword = (authResponse) => {
        updateDisplayedSection('credentialsUpdate');
        setEmail(authResponse.email);
        setUsername(authResponse.username);
    };

    const getAccountUsername = async (accountInfo) => {
        scrollTo(0, 0);
        setError(null);
        setIsFetchingUsername(true);
        try {
            const { username: retrievedUserName } = await retrieveUsername(accountInfo);
            setForgotCredsUsername(retrievedUserName);
            tagForm({
                fields: {
                    account_number: accountInfo.accountNumber,
                    phone_number: accountInfo.phoneNumber,
                    postal_code: accountInfo.postalCode,
                },
                name: 'forgot-username',
                success: true,
            });
            localizedPush(AppRoutes.loginPage);
        } catch (e) {
            setIsFetchingUsername(false);

            const errMessage = forgotUserNameErrors[e.response && e.response.status];

            if (errMessage) {
                setError(errMessage);
            } else {
                tagForm({
                    fields: {
                        account_number: accountInfo.accountNumber,
                        phone_number: accountInfo.phoneNumber,
                        postal_code: accountInfo.postalCode,
                    },
                    message: e.message,
                    name: 'forgot-username',
                    success: false,
                });
                localizedPush(AppRoutes.connectionFailurePage);
            }
        }
    };

    const onCredentialSubmit = () => {
        alert('credential updated');
    };

    const changeRecoverType = (event) => {
        setRecoverType(event.target.value);
    };

    const onBackToForgotCredentials = () => {
        updateDisplayedSection('forgotCredentials');
        setUsername(null);
    };

    const forgotCredentialsSection = (
        <div>
            <div className="credential-sto-container">
                <RadioButton
                    checked={recoveryType === 'password'}
                    id="credentialStatePassword"
                    label="pages.credentials.radio1"
                    name="credentialState"
                    onChange={changeRecoverType}
                    value="password"
                ></RadioButton>

                <RadioButton
                    checked={recoveryType === 'username'}
                    id="credentialStateUsername"
                    label="pages.credentials.radio2"
                    name="credentialState"
                    onChange={changeRecoverType}
                    value="username"
                ></RadioButton>
            </div>
            <div>
                {recoveryType === 'password' ? (
                    <RetrievePassword onSubmit={forgotPassword} />
                ) : (
                    <AccountDetailsForm error={error} onSubmit={getAccountUsername} />
                )}

                <div className="pprlpay-link-container">
                    <Link id="page-forgotCredential-button-backToLogin" to={AppRoutes.baseRoute}>
                        <FormattedMessage id="pages.credentials.login" />
                    </Link>
                </div>
            </div>
        </div>
    );

    const updateCredentialsSection = (
        <div>
            <UpdatePasswordForm email={email} onSubmit={onCredentialSubmit} username={username} />
            <div className="pprlpay-link-container">
                <TextButtonSto
                    className="button-link sto-links"
                    id="page-forgotCredential-button-forgotYourLogin"
                    labelKey="pages.login.forgotlogin"
                    onClick={onBackToForgotCredentials}
                    type="button"
                />
            </div>
        </div>
    );

    return (
        <div className="forgot-credential-page-content pprlpay-page-wrapper grey-banner">
            {isFetchingUsername && <OverlaySpinner />}
            <FocusableHeader className="forgot-credential-title">
                <FormattedMessage
                    id={
                        displayedSection === 'credentialsUpdate'
                            ? recoveryType === 'password'
                                ? 'pages.credentials.passwordreset.title'
                                : 'pages.credentials.login.title'
                            : 'pages.credentials.title'
                    }
                />
            </FocusableHeader>
            <hr className="fs-bar orange" />
            <h2 className="forgot-credential-subtitle">
                <FormattedMessage
                    id={
                        displayedSection === 'credentialsUpdate'
                            ? recoveryType === 'password'
                                ? 'pages.credentials.passwordreset.subTitle'
                                : 'pages.credentials.login.subTitle'
                            : 'pages.credentials.subTitle'
                    }
                />
            </h2>

            <div
                className="wrapper-message pprlpay-page-primary-content"
                style={displayedSection === 'credentialsUpdate' ? { marginTop: '5px' } : {}}
            >
                {displayedSection === 'credentialsUpdate' ? (
                    recoveryType === 'password' ? (
                        <div className="forgot-password-subtitle">
                            <FormattedMessage id="pages.forgotPassword.subTitle" values={{ email: email }} />
                        </div>
                    ) : (
                        ''
                    )
                ) : (
                    ''
                )}
                {displayedSection === 'credentialsUpdate' ? updateCredentialsSection : forgotCredentialsSection}
            </div>
        </div>
    );
};

export default RetrieveCredentialsView;
